export enum TypeUser {
  company_common = 0,
  company_administrator = 1,
  gertec_master = 2,
  company_owner = 3
}
